#import "./timeZoneInfo.gql"

query GetAllTimeZones {
  timeZones {
    ...timeZoneInfo
  }
}
